var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedinshare",
    transform: "translate(0.48 0.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3024",
    "data-name": "Ellipse 3024",
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    transform: "translate(-0.48 -0.099)",
    fill: "#007ab9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13594",
    "data-name": "Group 13594",
    transform: "translate(21.107 18.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24424",
    "data-name": "Path 24424",
    d: "M54.489,40.033V50.172H48.61v-9.46c0-2.375-.849-4-2.977-4a3.215,3.215,0,0,0-3.015,2.149,4.023,4.023,0,0,0-.195,1.433v9.874H36.544s.079-16.022,0-17.68h5.879V35c-.012.02-.028.039-.039.058h.039V35a5.837,5.837,0,0,1,5.3-2.921c3.868,0,6.767,2.527,6.767,7.956ZM30.395,23.969a3.063,3.063,0,1,0-.077,6.11h.038a3.065,3.065,0,1,0,.039-6.11Zm-2.977,26.2h5.877V32.491H27.417Z",
    transform: "translate(-27.068 -23.969)",
    fill: "#f1f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinshare);
export default __webpack_public_path__ + "static/media/linkedinshare.124345f18c2012842d0774f982483c3d.svg";
export { ForwardRef as ReactComponent };